export class Point {
    constructor(
        private _timestamp: number,
        private _value: number
    ) {}

    get timestamp() { return this._timestamp }
    get value() { return this._value }
}
